// extracted by mini-css-extract-plugin
module.exports = {"mark":"LottieLoader_mark__IXP5G"};